import { useData, ADMIN_TABLE } from "../../context/DataContext";
import TaskTable from "../../components/TaskTable";
import { STATUS_OPTIONS } from "../../utils/helpers";

export default function AllTasksAdmin() {
  const { adminRecords, loading } = useData();
  if (loading && adminRecords.length === 0) return <div className="loading-box"><div className="spinner" /><span>Loading...</span></div>;
  return (
    <div className="fade-in">
      <TaskTable
        title="📋 All Tasks"
        records={adminRecords}
        tableId={ADMIN_TABLE}
        canEdit
        canDelete
        emptyMsg="No tasks found."
        statusOptionsOverride={STATUS_OPTIONS}
        kanbanLayout="5col"
      />
    </div>
  );
}
